<template lang="pug">
  .new-user-promotion-resend-button
    v-button.btn-primary(:loading="form.busy", nativeType="button", @click="resendEmail()")
      slot Resend email
    .resend-email-status(v-if="showStatus") {{ successLabel }}
</template>

<script>
import Form from 'vform'

export default {
  name: 'new-user-promotion-resend-button',

  props: {
    successLabel: {
      type: String,
      default: 'Email resent'
    }
  },

  data: () => ({
    form: new Form({
      email: ''
    }),
    showStatus: false
  }),

  created() {
    this.form.email = this.$parent.email;
  },

  methods: {
    async resendEmail () {
      this.showStatus = false;
      const { data } = await this.form.post(`${window.addiesaas.url}/api/register/promotion/resend`);
      if (data) {
        this.showStatus = true;
      } else {
        this.$parent.$emit('reset');
      }
    }
  }
}
</script>
